import React from 'react';
import { retryLazyImport } from '../../Store/SessionManager';
// import './FormComponent.scss';

import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import dayjs from 'dayjs';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { TimePicker } from '@mui/x-date-pickers/TimePicker';

import CustomFormTitle from './CustomFormTitle';
import styled from 'styled-components';
import { FormTimePickerInterface } from '../../Models/Common/FormFieldComponentInterfaces';
import LocalStorageHelper from '../../Utilities/Helpers/LocalStorageHelper';

const CustomTooltip = React.lazy(() => retryLazyImport(() => import('./CustomTooltip')));

const StyledPickerContainer = styled.div<{ $isdarkmode: boolean; }>`
    .MuiStack-root {
        overflow: unset !important;
        max-height: 41px;
        width: 100%;

        .MuiFormControl-root.MuiPickersTextField-root {
            max-height: 41px;
            width: 100%;
            height: 35px;

            .MuiPickersInputBase-root.MuiPickersOutlinedInput-root.MuiPickersInputBase-colorPrimary.MuiPickersInputBase-adornedEnd {
                font-size: 14px !important;
                max-height: 41px;
                padding: 4px 0px 0px 10px !important;

                .MuiPickersSectionList-root.MuiPickersInputBase-sectionsContainer {
                    max-height: 41px;
                    padding: 0px;
                }

                .MuiPickersOutlinedInput-notchedOutline {
                    max-height: 41px;
                    height: 41px;
                }
            }
        }

        .MuiFormControl-root.MuiPickersTextField-root.Mui-disabled {
            background-color: ${(props) => (props.$isdarkmode ? '#242728' : '#e9ebec')};

            .MuiPickersInputBase-root.MuiPickersOutlinedInput-root.Mui-disabled.MuiPickersInputBase-colorPrimary.MuiPickersInputBase-adornedEnd {
                .MuiPickersSectionList-root.MuiPickersInputBase-sectionsContainer {
                    .MuiPickersSectionList-section {
                        .MuiPickersSectionList-sectionContent.MuiPickersInputBase-sectionContent {
                            color: #564f4f !important
                        }
                        
                    }
                }
            }
        }
    }
    .MuiInputBase-root {
        max-height: 37px !important;
        font-size: 0.9rem !important;
        color: ${props => props.theme.primaryText};

        &::placeholder {
            color: var(--fieldFocusedBorderPrimaryColor);
            opacity: 0.8;
        }

        .Mui-disabled {
            background-color: ${(props) => (props.theme.disabled)};
        }
    }

    .MuiOutlinedInput-root {
        padding-right: 0px !important; //for icon
    }

    .MuiTextField-root {
        margin-top: 0px !important;
        background: ${props => props.theme.fieldBackgroundColor};
    }

    .MuiInputBase-input {
        padding:  7px 8px !important; //text padding
    }

    .MuiFormHelperText-root {
        margin-left: 0px !important; //helper margin
    }

    .MuiIconButton-root {
        margin-right: 0px !important;
    }

    .MuiStack-root {
        padding-top: 0px !important; //distance to title
    }

    .MuiInputAdornment-root {
        margin-left: 0px !important;
    }
`;

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.tz.setDefault("Asia/Kuala_Lumpur");

const FormTimePicker = (fieldProps: FormTimePickerInterface) => {
    let isDarkMode = LocalStorageHelper.isDarkMode();

    //Variables
    let message: any = (fieldProps.errorMessages && fieldProps.errorMessages[fieldProps.name] ?
        fieldProps.errorMessages[fieldProps.name] : null
    );

    //Rendering UIs
    const renderTimePickerUI = () => {
        const errorMsg = (fieldProps.errorMessages ? fieldProps.errorMessages[fieldProps.name] : null) ?? null;

        return <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DemoContainer components={['TimePicker', 'TimePicker']}>
                <TimePicker {...{
                    name: fieldProps.name,
                    placeholder: "",
                    value: fieldProps.fieldValue ? dayjs(new Date(fieldProps.fieldValue)) : null,
                    disabled: fieldProps.disabled,
                    onChange: (newValue: any) => {
                        if (fieldProps.handleOnChange) {
                            fieldProps.handleOnChange(newValue ? dayjs(newValue) : null);
                        }
                    },
                    slotProps: {
                        ...{
                            textField: {
                                error: errorMsg != null,
                                helperText: errorMsg,
                                placeholder: fieldProps.placeholder ?? ''
                            },
                        }
                    },
                }} />
            </DemoContainer>
        </LocalizationProvider>
    }

    return <StyledPickerContainer $isdarkmode={isDarkMode}>

        {/* ---------TITLE---------- */}
        <CustomFormTitle title={fieldProps.title}
            required={fieldProps.required}
            hideLabel={fieldProps.hideLabel}
            exclamationHoverItemDisplayText={fieldProps.exclamationHoverItemDisplayText} />

        {/* ---------TIME PICKER---------- */}
        {renderTimePickerUI()}
    </StyledPickerContainer>
}

export default FormTimePicker;